import React from 'react';
import TWConfirmModal from '../ui/tw-confirm-modal';

const ModalConfirm = ({
  open,
  onCloseRequest,
  title,
  onOk,
  item,
  loading,
  text,
  shouldConfirm = false,
}) => {
  const lowered = (title || '').toLowerCase();
  const description =
    text ||
    `You're about to remove your ${lowered} and all data belong to this ${lowered}. Are you sure you want to remove "${item?.name || ''}"?`;

  return (
    <TWConfirmModal
      open={open}
      onClose={onCloseRequest}
      onConfirm={() => {
        if (item?.id) onOk(item.id);
      }}
      loading={loading}
      tone="info"
      title={title}
      description={description}
      confirmLabel="Confirm"
      cancelLabel="Cancel"
      requireTypedConfirmation={shouldConfirm ? item?.name || '' : undefined}
    />
  );
};

export default ModalConfirm;
